import { Select } from '@shared/ui/select';

export interface FundSelectProps {
  options: readonly { value: number; label: string }[];
  value: number | null;
  onChange: (value: number) => void;
  placeholder?: string;
  disabled?: boolean;
  invalid?: boolean;
  'aria-label'?: string;
  /** 너비 등(기본은 부모 너비) */
  className?: string;
  /** 목록을 제자리에 그린다(확인 페이지) */
  inline?: boolean;
}

/** Select atom 에 펀드 · LP 선택지를 넣는 얇은 선택 상자. 선택지는 상위가 idx → value, 이름 → label 로 바꿔 넘긴다 */
export function FundSelect({ options, value, onChange, ...rest }: FundSelectProps) {
  const selectOptions = options.map((option) => ({
    value: String(option.value),
    label: option.label,
  }));
  return (
    <Select
      {...rest}
      size="md"
      options={selectOptions}
      value={value === null ? null : String(value)}
      onChange={(next) => onChange(Number(next))}
    />
  );
}
